import DOMPurify from 'dompurify';
import isEmail from 'validator/lib/isEmail';
import isStringEmpty from 'validator/lib/isEmpty';
import isMobilePhone from 'validator/lib/isMobilePhone';
import { isDomainBlocked } from "../ui/components/InputMessage";

export const checkFieldValue = ({key, value = ''}, Language, validateDomains = false) => {
    let error = null;
    switch(key) {
        case 'email':
            if (!isEmail(value)) {
                error = Language && Language.ValidationValidEmailAddress;
                break;
            } else if(validateDomains) {
                let domain = value.substring(value.lastIndexOf("@") +1);
                if(isDomainBlocked(domain)){
                    error = Language && Language.InputMessageBusinessEmailError;
                }
            }
            break;
        case 'phone':
            if (!isMobilePhone(value)) {
                error = Language && Language.ValidationValidPhoneNumber;
            }
            break;
        default:
            const clean = DOMPurify.sanitize(value, { ALLOWED_TAGS: [] });
            if (isStringEmpty(value) || (clean !== value)) {
                error = Language && Language.ValidationEnterDetails;
            }
            break;
    }

    return error
}


export const  isEmpty = (val) => {
    return (val === undefined || val == null || val.length <= 0) ? true : false;
}
